

import { BasicProperties } from "../BasicProperties";

export class BasicReconnectDialogProperties extends BasicProperties {
    public buttonLabel_reconnect: string = "Try again";
    public copy: string = "";
    public title: string = "";
    public functionReconnect: Function;

    constructor(title: string, copy: string, functionReconnect: Function = null, buttonLabel_reconnect: string = "Try again") {
        super();
        this.functionReconnect = functionReconnect;
        this.buttonLabel_reconnect = buttonLabel_reconnect;
        this.title = title;
        this.copy = copy;
    }
}

